import { createFeatureSelector, createSelector } from '@ngrx/store';

import { paymentMethodsAdapter, PaymentMethodsEntityState, paymentMethodsFeatureKey } from './methods.reducer';

const { selectAll, selectEntities, selectIds } = paymentMethodsAdapter.getSelectors();

const selectPaymentState = createFeatureSelector<PaymentMethodsEntityState>(paymentMethodsFeatureKey);

export const selectPaymentMethods = createSelector(selectPaymentState, (state) => selectAll(state));
export const selectPaymentMethodsMap = createSelector(selectPaymentState, (state) => selectEntities(state));
export const selectPaymentMethodsIds = createSelector(selectPaymentState, (state) => selectIds(state));

export const selectPaymentMethodsLoaded = createSelector(selectPaymentState, (state) => state.loaded);
export const selectPaymentMethodsError = createSelector(selectPaymentState, (state) => state.error);
